import { motion } from 'framer-motion';
import { FiX } from 'react-icons/fi';
import styled from 'styled-components';

export const Modal = styled(motion.div)`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 42;
  display: ${({ hideModal }) => (hideModal ? 'none' : '')};
`;

export const CloseIcon = styled(FiX)`
  color: ${({ theme }) => theme.COLOR_GREY_TEXT};
  cursor: pointer;
  background-color: ${({ theme }) => theme.COLOR_WHITE};
`;

export const FloatingCloseIcon = styled(FiX)`
  color: ${({ theme }) => theme.COLOR_TEXT};
  cursor: pointer;
`;

export const ModalContent = styled(motion.div)`
  height: ${({ height }) => height || 'auto'};
  min-height: ${({ $minHeight }) => $minHeight || 'auto'};
  max-height: 95vh;
  padding: ${({ $padding }) => $padding};
  width: ${({ width }) => width || '85vw'};
  border-radius: 4px;
  background-color: #fff;
  min-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: ${({ $alignItems }) => $alignItems || 'center'};
  justify-content: center;
`;

export const ModalHeader = styled.div`
  padding: ${({ $headerPadding }) => $headerPadding || '15px 0px 10px 10px'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  position: sticky;
  color: ${(props) => props.theme.inputPrimaryFontColor};
  width: 100%;
  .close-icon {
    cursor: pointer;
    margin: 10px 15px 0px 0px;
  }
  margin-bottom: auto;
`;

export const ModalTitle = styled.div`
  margin-left: ${({ $margin }) => $margin || '15px'};
  flex-grow: 4;
  display: flex;
  color: ${({ theme }) => theme.COLOR_BLACK};
  font-size: ${({ $titleFontSize }) => $titleFontSize || '20px'};
`;

export const SecondaryHeaderItem = styled.div`
  flex-grow: 0.1;
  margin: 0px 15px 0px 0px;
  padding: 0;
`;

export const SecondaryHeaderItemPortal = styled.div`
  flex-grow: 0.3;
  margin: 0px 15px 0px 0px;
  padding: 0;
`;

export const ModalBody = styled.div`
  padding: 10px;
  overflow-x: hidden;
  z-index: 1;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  display: flex;
`;

export const Icon = styled.div`
  position: absolute;
  right: 5px;
  top: 5px;
  cursor: pointer;
  svg {
    fill: ${(props) => props.theme.inputPrimaryFontColor};
  }
  @media (hover: hover) {
    &:hover {
      color: ${({ theme }) => theme.COLOR_BLACK};
    }
  }
`;

export const FloatingCloseButton = styled.div`
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
  position: fixed;
  width: 32px;
  height: 32px;
  top: 10px;
  right: 10px;
  border-radius: 50px;
  text-align: center;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SuccessContainer = styled.div`
  border: 0.5px solid #39c568;
  background: rgba(57, 197, 104, 0.2);
  color: #81a785;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 20px;
  width: 96%;
  height: 100%;
  font-size: 14px;
  font-weight: 700;
  border-radius: 4px;
  margin: 0 0 3% 2%;

  svg {
    margin: 0 10px 0 0;
  }
`;

export const HeaderDiv = styled.div`
  color: #fe0000;
  display: flex;
  align-items: center;
  padding: 10px 0;
`;

export const InnerDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border: 0.5px solid #fe0000;
  background: white;
  padding: 5px 10px;
  width: 100%;
  height: 100%;
  font-size: 14px;
  font-weight: 500;

  table {
    width: 100%;
    border: 2px;

    tr {
      td {
        padding: 0 5px;
      }
    }
  }
`;

export const FailedContainer = styled.div`
  border: 0.5px solid #fe0000;
  background: rgba(254, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 5px 20px 20px;
  width: 96%;
  max-height: 49vh;
  font-size: 14px;
  font-weight: 700;
  margin: 0 2% 15px 2%;

  svg {
    margin: 0 10px 0 0;
  }
`;

export const ButtonHolder = styled.div`
  margin-top: 0;
  padding: 5px 15px 10px 15px;
  display: flex;
  justify-content: flex-end;
`;
